export const getWindow = (defaultValue = null) =>
	typeof window === 'undefined' ? defaultValue : window;

export const hasWindow = () => typeof window !== 'undefined';

export const getDocument = (defaultValue = null) =>
	typeof document === 'undefined' ? defaultValue : document;
